









































































































































































































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'washings', 'meta_washings'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError,
    ...mapActions(STORE_KEY, [
      'addWashing', 'removeWashing', 'setWashingValue'
    ])
  },
  validations() {
    const rules: any = {
      name: { required },
      type: { required },
      prefix: { },
      volume: { },
      parts_count: { },
      count: { },
      is_wash: {},
      show_in_planning: {},
      delay: {},
      periodicity: {},
      periodicity_value: {},
      water_volume: {},
      detergent_volume: {},
      detergent_concentration: {},
    }

    return {
      form: rules
    }
  }
})
export default class VolumeManagerForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any
  washings!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }
  onWashingValue(index: number, object: any) {
    if (this.washings[index] && !this.washings[index].water_volume) {
      this.washings[index].water_volume = parseFloat(object.water_volume);

    }
    if (this.washings[index] && !this.washings[index].detergent_volume) {
      this.washings[index].detergent_volume = parseFloat(object.detergent_volume);

    }
    if (this.washings[index] && !this.washings[index].detergent_concentration) {
      this.washings[index].detergent_concentration = parseFloat(object.detergent_concentration);
    }
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

